import React, { useState, useEffect } from 'react';
import logo from '../assets/images/logo.png';

const TestLoadingOverlay = ({ isVisible }) => {
  const allLoadingMessages = [
    "Hacking university database to steal next semester's questions...",
    "Bribing the AI with virtual cookies...",
    "Teaching AI how to write impossible questions...",
    "Convincing ChatGPT to be less friendly...",
    "Calculating the perfect amount of trick questions...",
    "Searching Stack Overflow for the hardest questions...",
    "Mixing easy and impossible questions for maximum chaos...",
    "Consulting with evil professors for inspiration...",
    "Adding extra difficult options just for fun...",
    "Making sure the answers are more confusing than the questions...",
    "Generating questions that even the AI can't answer...",
    "Adding a sprinkle of 'Wait, we didn't cover this!'...",
  ];

  // Always start with analyzing notes and end with finalizing
  const startMessage = "Analyzing your notes...";
  const endMessage = "Finalizing your test...";

  const [loadingMessages, setLoadingMessages] = useState([]);
  const [currentMessage, setCurrentMessage] = useState(0);

  // When overlay becomes visible, randomly select messages
  useEffect(() => {
    if (isVisible) {
      // Randomly select just 1 funny message
      const shuffled = [...allLoadingMessages]
        .sort(() => 0.5 - Math.random())
        .slice(0, 1);

      // Combine with start and end messages
      setLoadingMessages([
        startMessage,
        shuffled[0],
        endMessage
      ]);
      setCurrentMessage(0);
    }
  }, [isVisible]);

  useEffect(() => {
    if (isVisible && loadingMessages.length > 0) {
      // Set up different timers for each message transition
      const timers = [
        // First message ("Analyzing...") shows for 3.5s
        setTimeout(() => setCurrentMessage(1), 3500),
        // Second message (funny one) shows for 3.5s
        setTimeout(() => setCurrentMessage(2), 7000),
        // Last message ("Finalizing...") shows until complete
      ];

      return () => timers.forEach(timer => clearTimeout(timer));
    }
  }, [isVisible, loadingMessages.length]);

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 bg-dark-bg z-50 flex flex-col items-center justify-center">
      {/* Grid Background */}
      <div 
        className="absolute inset-0 opacity-5"
        style={{
          backgroundImage: 'radial-gradient(circle, #ffffff 1px, transparent 1px)',
          backgroundSize: '30px 30px'
        }}
      ></div>

      {/* Content */}
      <div className="relative z-10 max-w-xl w-full px-4">
        {/* Logo */}
        <div className="flex justify-center mb-8">
          <img 
            src={logo} 
            alt="Notui Logo" 
            className="h-12 w-auto"
          />
        </div>

        <h1 className="text-3xl font-bold text-white text-center mb-12">
          Generating Your Test
          <span className="text-blue-500">...</span>
        </h1>

        {/* Loading Bar */}
        <div className="w-full bg-dark-card rounded-full h-2 mb-8 overflow-hidden">
          <div 
            className="h-full bg-blue-500 transition-all duration-300 ease-out"
            style={{ 
              width: `${((currentMessage + 1) / loadingMessages.length) * 100}%`,
            }}
          ></div>
        </div>

        {/* Loading Message */}
        <div className="min-h-[3rem] text-center">
          <p className="text-gray-400 animate-fade-in">
            {loadingMessages[currentMessage]}
          </p>
        </div>

        {/* Spinner */}
        <div className="mt-8 flex justify-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
        </div>
      </div>
    </div>
  );
};

export default TestLoadingOverlay; 